import { render, staticRenderFns } from "./ProrrogarBoletoAvulsoDialog.vue?vue&type=template&id=1791dc3d&"
import script from "./ProrrogarBoletoAvulsoDialog.vue?vue&type=script&lang=js&"
export * from "./ProrrogarBoletoAvulsoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports